<template>
  <v-navigation-drawer
    :value="showDrawer"
    temporary
    fixed
    right
    width="500"
    :disable-route-watcher="true"
    stateless
    :class="isNuovoClifor ? 'green lighten-5' : isEditClifor ? 'blue lighten-5' : ''"
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{drawerTitle}}</v-list-item-title>
          <v-list-item-subtitle>{{drawerSubtitle}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-list dense>
        <v-list-item
          v-for="item in clienteItems"
          :key="item.label"
        >
          <v-list-item-content>
            <v-list-item-title>
              <component :is="'p' + item.type" :item="item" :appoggio="locCliente" @change="componentValueChange" :disabled="readOnly" :updateTrigger="triggerUpdate" :verificaDefault="forceCheckDefault"/>
              
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-form>
    <template v-slot:append>
      <v-container fluid>
        <v-row align="center">
          <v-col class="d-flex justify-space-around" cols="12" sm="6" v-if="!readOnly">
            <v-btn color="success mb-2" @click="onSalva">Salva</v-btn>
          </v-col>
          <v-col class="d-flex justify-space-around" cols="12" sm="6">
            <v-btn color="secondary mb-s" @click="onAnnulla" >{{annullaTitle}}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-navigation-drawer>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import pTesto from '@/views/drawer/elementi/testo'
import pMultiselect from '@/views/drawer/elementi/multiselect'
import pSwitch from '@/views/drawer/elementi/switch'
import pDestinazioni from '@/views/drawer/elementi/destinazioni'
import pPartitaIva from '@/views/drawer/elementi/partitaIva'
import pPaCodiceFiscale from '@/views/drawer/elementi/paCodiceFiscale'

export default {
  components: {
    pTesto,
    pMultiselect,
    pSwitch,
    pDestinazioni,
    pPartitaIva,
    pPaCodiceFiscale
  },
  data: () => ({
    backoffice: null,
    impostazioni: null,
    show: false,
    locCliente: null,
    formFieldsValid: true,
    triggerUpdate: 1,
    forceCheckDefault: 1    
  }),
  async mounted() {
    const confBackoffice = await configurazioni.getConfigurazione('backoffice')
    // this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
    this.backoffice = confBackoffice.pagine
    this.impostazioni = confBackoffice.impostazioni
    this.locCliente = this.$store.getters['clienti/cliente'] || null
  },
  watch: {
    cliente(value) {
      this.locCliente = value
    }
  },
  computed: {
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza cliente'
      } else {
        return this.locCliente && this.locCliente._id ? 'Modifica cliente/fornitore' : 'Nuovo cliente/fornitore'
      }
    },
    drawerSubtitle() {
      return this.locCliente ? `${this.locCliente.codice} - ${this.locCliente.ragioneSociale}` : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    cliente() {
      return this.$store.getters['clienti/cliente'] || null // || { codice: '', descrizione: '' }
    },
    clienteItems() {
      if (!this.locCliente || !this.backoffice) {
        return []
      }
      const vars = this.backoffice.clienti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        items.push({value: dot.pick(item.valueField, this.locCliente), ...item})
      }
      return items
    },
    isNuovoClifor() {
      return this.$store.getters['clienti/creaClifor']
    },
    isEditClifor() {
      return this.$store.getters['clienti/editClifor']
    }    
  },
  methods: {
    async componentValueChange(data) {
      const { model, subModel, value, azienda, defaultUsed, checkDefault } = data
      if (azienda) {
        this.locCliente = azienda
        return
      }
      let tgt = {}
      if (subModel) {
        dot.str(model, value[subModel], tgt)
      } else {
        dot.str(model, value, tgt)
      }
      _.merge(this.locCliente, tgt)
      await this.$nextTick()
      if (checkDefault) {
        this.forceCheckDefault++
      }
      this.triggerUpdate++
      // this.aggiornaCorrelati(data) // TODO: Completare
    },
    /*     aggiornaCorrelati(data) {
      this.locCliente.appoggio = this.locCliente.appoggio || {}
      switch (data.model) {

      }
    }, */
    onAnnulla() {
      this.$refs.form.reset()
      if (this.isNuovoClifor) {
        // Drawer clienti richiamato da movimenti o documenti
        this.$store.commit('clienti/CLEAR_CREA_CLIFOR')
      } else if (this.isEditClifor) {
        this.$store.commit('clienti/CLEAR_EDIT_CLIFOR')
      } else {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$store.commit('clienti/SET_REFRESH')
      }      
    },
    async onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        if (this.isNuovoClifor || this.isEditClifor) {
          await this.salvaSuDB()
        } else {
          if (!this.locCliente.codice) {
            await this.creaCodiceCliente()
          }
          this.$store.commit('clienti/SET_CLIENTE', this.locCliente)
          this.$store.commit('clienti/SET_CLIENTE_SAVED')
          await this.$nextTick()
          this.locCliente = null
        }
      }    
    },
    async creaCodiceCliente() {
      const tipo = this.locCliente.amministrativi.cliente ? 'clienti' : 'fornitori'
      const impo = this.impostazioni[tipo]
      var numeratore
      if (impo.tipoNumeratore === '_') {
        const pattern = /[^a-zA-Z0-9-]+/gi
        numeratore = this.locCliente.ragioneSociale.trim().replace(/\s\s+/g, ' ').replace(pattern, '_').toLowerCase()
      } else {
        numeratore = await configurazioni.getNumeratore(impo.tipoNumeratore, true)
      }
      this.locCliente.codice = numeratore
      this.locCliente._id = numeratore
    },
    async salvaSuDB() {
      const id = this.locCliente._id
      let cliente = null
      if (id) {
        cliente = await clienti.modificaCliente(this.locCliente)
        if (!cliente) {
          this.dialogErrore = true
          return
        }
        this.$store.commit('clienti/CLEAR_EDIT_CLIFOR')
      } else {
        await this.creaCodiceCliente()
        cliente = await clienti.creaCliente(this.locCliente)
        if (!cliente) {
          this.dialogErrore = true
          return
        }
        this.$store.commit('clienti/CLEAR_CREA_CLIFOR')
        this.$store.commit('clienti/SET_CLIFOR_CREATO', cliente)
      }
      await this.$nextTick()
      this.locCliente = null
    }    
  }
}
</script>